module.exports = __webpack_public_path__ + "static/media/logo.e7888d85.png";